import { render, staticRenderFns } from "./SfHeaderChange.vue?vue&type=template&id=23edc58e"
import script from "./SfHeaderChange.vue?vue&type=script&lang=js"
export * from "./SfHeaderChange.vue?vue&type=script&lang=js"
import style0 from "./SfHeaderChange.vue?vue&type=style&index=0&id=23edc58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports